import { orderBy } from 'lodash-es'

import ExtendedMap from '@/models/ExtendedMap'

import { HomeworkHistory } from './HomeworkHistory'

export class HomeworkHistoryColl {
  map: ExtendedMap<HomeworkHistory['clientId'], HomeworkHistory>

  constructor(homeworkHistories: res.HomeworkHistory[]) {
    const arr = homeworkHistories.map((data) => new HomeworkHistory(data))

    this.map = ExtendedMap.fromArr(arr, 'clientId')
  }

  get latestOrderHistoryList() {
    const flatData = this.map.toArr.map((d) => d.historyDataList)
    const data = orderBy(flatData.flat(), [(data) => data?.createDatetime], ['desc'])

    return data
  }
  clear() {
    this.map.clear()
  }
}
